import React from 'react'
import PanelSearchEmail from '../search/PanelSearchEmail'
import TableProductSearch from './TableProductSearch'

function PanelProductSearchEmail({
  email,
}) {
  return (
    <PanelSearchEmail
      email={email}
      TableComponent={TableProductSearch} />
  )
}

export default (PanelProductSearchEmail)